import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import { useFormContext, type FieldValues } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import {
  activityFrequencyDictionary,
  activityFrequencySchema,
} from "./schedulingModels";
import {
  useFieldPathWithPrefix,
  useFieldErrorWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import { useIsInFinalValidationPhase } from "@/pages/template-manager/TemplateFieldValidationContext";
import type { TemplateFrequencyPickerFields } from "@/pages/template-manager/TemplateForm/templateFormSchema";

export const TemplateFrequencyPicker = () => {
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const { t } = useLingui();
  const fieldName =
    useFieldPathWithPrefix<TemplateFrequencyPickerFields>("frequency");
  const errorMessage = useFieldErrorWithPrefix<TemplateFrequencyPickerFields>(
    errors,
    "frequency",
  );
  const isInFinalValidationPhase = useIsInFinalValidationPhase();

  const frequencyField = register(fieldName, {
    required: isInFinalValidationPhase
      ? {
          value: true,
          message: t`Sätt upprepningsmönster`,
        }
      : undefined,
  });

  return (
    <RadioButtons
      legend={t`Frekvens`}
      errorMessage={errorMessage}
      orientation="horizontal"
    >
      <RadioButton
        label={{ text: t(activityFrequencyDictionary.oneTime) }}
        {...frequencyField}
        value={activityFrequencySchema.enum.oneTime}
        visualStyle="framed"
      />
      <RadioButton
        label={{ text: t(activityFrequencyDictionary.recurring) }}
        {...frequencyField}
        value={activityFrequencySchema.enum.recurring}
        visualStyle="framed"
      />
    </RadioButtons>
  );
};
